/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { setToken, isType, setPartiallyAuth } from "../actions";
import { Auth } from "../../types/RootState";

const initialState: Auth = {
    token: null,
};

export default function authReducer(state: Auth = initialState, action): Auth {
    if (isType(action, setToken)) {
        return {
            ...state,
            token: action.payload,
        };
    }
    if (isType(action, setPartiallyAuth)) {
        return {
            ...state,
            ...action.payload,
        };
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/auth.reducer.ts